import { Schema } from "effect";
import { CanonicalIdentifierSchema } from "./standard";

export const IdSchema = CanonicalIdentifierSchema.check(Schema.isMaxLength(128));
export const UserIdSchema = IdSchema.pipe(Schema.brand("UserId"));
export const WorkspaceIdSchema = IdSchema.pipe(Schema.brand("WorkspaceId"));
export const ProjectIdSchema = IdSchema.pipe(Schema.brand("ProjectId"));
export const EnvironmentIdSchema = IdSchema.pipe(Schema.brand("EnvironmentId"));
export const ApiProjectIdSchema = IdSchema.pipe(Schema.brand("ApiProjectId"));
export const ApiEnvironmentIdSchema = IdSchema.pipe(Schema.brand("ApiEnvironmentId"));
export const ThreadIdSchema = IdSchema.pipe(Schema.brand("ThreadId"));
export const ArtifactIdSchema = IdSchema.pipe(Schema.brand("ArtifactId"));
export const ArtifactRevisionIdSchema = IdSchema.pipe(Schema.brand("ArtifactRevisionId"));
export const ApiKeyIdSchema = IdSchema.pipe(Schema.brand("ApiKeyId"));
export const ConnectionIdSchema = IdSchema.pipe(Schema.brand("ConnectionId"));
export const CalendarEventIdSchema = IdSchema.pipe(Schema.brand("CalendarEventId"));
export const CalendarExternalEventIdSchema = IdSchema.pipe(Schema.brand("CalendarExternalEventId"));
export const CalendarOperationIdSchema = IdSchema.pipe(Schema.brand("CalendarOperationId"));
export const CalendarSyncJobIdSchema = IdSchema.pipe(Schema.brand("CalendarSyncJobId"));
export const RequestIdSchema = IdSchema.pipe(Schema.brand("RequestId"));

export const decodeUserId = Schema.decodeSync(UserIdSchema);
export const decodeWorkspaceId = Schema.decodeSync(WorkspaceIdSchema);
export const decodeProjectId = Schema.decodeSync(ProjectIdSchema);
export const decodeApiProjectId = Schema.decodeSync(ApiProjectIdSchema);
export const decodeApiEnvironmentId = Schema.decodeSync(ApiEnvironmentIdSchema);
export const decodeRequestId = Schema.decodeSync(RequestIdSchema);
export const encodeWorkspaceId = Schema.encodeSync(WorkspaceIdSchema);
export const encodeProjectId = Schema.encodeSync(ProjectIdSchema);
export const encodeApiProjectId = Schema.encodeSync(ApiProjectIdSchema);
export const encodeApiEnvironmentId = Schema.encodeSync(ApiEnvironmentIdSchema);

export type UserId = typeof UserIdSchema.Type;
export type UserIdEncoded = typeof UserIdSchema.Encoded;
export type WorkspaceId = typeof WorkspaceIdSchema.Type;
export type WorkspaceIdEncoded = typeof WorkspaceIdSchema.Encoded;
export type ProjectId = typeof ProjectIdSchema.Type;
export type ProjectIdEncoded = typeof ProjectIdSchema.Encoded;
export type EnvironmentId = typeof EnvironmentIdSchema.Type;
export type EnvironmentIdEncoded = typeof EnvironmentIdSchema.Encoded;
export type ApiProjectId = typeof ApiProjectIdSchema.Type;
export type ApiProjectIdEncoded = typeof ApiProjectIdSchema.Encoded;
export type ApiEnvironmentId = typeof ApiEnvironmentIdSchema.Type;
export type ApiEnvironmentIdEncoded = typeof ApiEnvironmentIdSchema.Encoded;
export type ThreadId = typeof ThreadIdSchema.Type;
export type ThreadIdEncoded = typeof ThreadIdSchema.Encoded;
export type ArtifactId = typeof ArtifactIdSchema.Type;
export type ArtifactIdEncoded = typeof ArtifactIdSchema.Encoded;
export type ArtifactRevisionId = typeof ArtifactRevisionIdSchema.Type;
export type ArtifactRevisionIdEncoded = typeof ArtifactRevisionIdSchema.Encoded;
export type ApiKeyId = typeof ApiKeyIdSchema.Type;
export type ApiKeyIdEncoded = typeof ApiKeyIdSchema.Encoded;
export type ConnectionId = typeof ConnectionIdSchema.Type;
export type ConnectionIdEncoded = typeof ConnectionIdSchema.Encoded;
export type CalendarEventId = typeof CalendarEventIdSchema.Type;
export type CalendarEventIdEncoded = typeof CalendarEventIdSchema.Encoded;
export type CalendarExternalEventId = typeof CalendarExternalEventIdSchema.Type;
export type CalendarExternalEventIdEncoded = typeof CalendarExternalEventIdSchema.Encoded;
export type CalendarOperationId = typeof CalendarOperationIdSchema.Type;
export type CalendarOperationIdEncoded = typeof CalendarOperationIdSchema.Encoded;
export type CalendarSyncJobId = typeof CalendarSyncJobIdSchema.Type;
export type CalendarSyncJobIdEncoded = typeof CalendarSyncJobIdSchema.Encoded;
export type RequestId = typeof RequestIdSchema.Type;
export type RequestIdEncoded = typeof RequestIdSchema.Encoded;
